import React from 'react'
import { CaptionLight } from '../../../components'
import { StyledRow } from './styled'

const TH = ({ children }) => (
  <th>
    <CaptionLight>{children}</CaptionLight>
  </th>
)

export const CapabilitiesTableHead = () => (
  <thead>
    <StyledRow>
      <TH>Title</TH>
      <TH>Description</TH>
      <TH>Edition Types</TH>
      <TH>Publishing Location</TH>
      <TH>Publishing Destination</TH>
      <TH>Required Media Type Group</TH>
      <TH>Supported Media Type Group</TH>
    </StyledRow>
  </thead>
)
